import { render } from "./IconMoon.vue?vue&type=template&id=6fe8e154"
import script from "./IconMoon.vue?vue&type=script&lang=js"
export * from "./IconMoon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__